import { html, TemplateResult } from "lit-html"
import { currentScreenAndDialog } from "../../.."
import { SYSBaseElement } from "../../sysbaseelement"
import { startTrack } from "../../../tracker/tracker"

export class SYSScreenContainer extends SYSBaseElement {
  async getUI() {
    startTrack(this)
    this.state.ovl.screens.nav.screenCounter
    return currentScreenAndDialog.screens.map((r) => {
      return html`${r}`
    })
  }
}
